import React from 'react';
import { motion } from 'framer-motion';
import PrivacyPolicyModal from '../components/PrivacyPolicyModal';
import '../Styles/Privacy.css';

const sections = [
    {
        title: 'Data Collection and Retention',
        content: `Cyphr Systems is dedicated to protecting user privacy. Our apps may collect temporary, non-personal data strictly for operational purposes, such as during active sessions. This data is automatically and permanently deleted once the session concludes or the operational need ends. Cyphr Systems does not retain or access any personal information beyond what is required to ensure app functionality.`
    },
    {
        title: 'No Data Collection Promise',
        content: `We do not collect, store, or share any personal data. Cyphr Systems is committed to a zero data collection policy—no data about you, your device, or your behavior is collected, tracked, or stored by default. Users retain full control over their data, and our systems are designed to operate without compromising privacy.`
    },
    {
        title: 'Temporary Operational Data Only',
        content: `In cases where temporary data collection is required to facilitate specific app features, such as active session tracking, data will only be retained for the duration of the session. After the session ends, all associated data is permanently deleted from Cyphr Systems servers, ensuring no trace of user data remains.`
    },
    {
        title: 'User Agreement on Data Handling',
        content: `By using Cyphr Systems apps, users acknowledge and consent to any temporary data handling solely for the purpose of app functionality. Users understand that no personal information will be accessed or retained under any circumstances.`
    },
    {
        title: 'Security and Compliance',
        content: `Cyphr Systems is dedicated to maintaining the highest standards of data security and privacy. We continually evaluate and improve our security protocols to ensure that users’ privacy is protected in compliance with relevant laws and regulations.`
    },
    {
        title: 'Limitation of Liability',
        content: `Cyphr Systems provides all apps on an “as-is” basis. We disclaim liability for any damages or losses that may arise from app use, including data loss or unauthorized access, although we strive to ensure a secure, seamless user experience.`
    },
    {
        title: 'Prohibited Uses and Responsibility',
        content: `Users agree not to engage in prohibited activities, including illegal, harmful, or malicious behavior, while using Cyphr Systems apps. Users are responsible for ensuring their use complies with all relevant laws.`
    },
    {
        title: 'Amendments to Terms',
        content: `Cyphr Systems reserves the right to modify or update these terms at any time. Continued use of Cyphr Systems apps indicates acceptance of any updates to these terms.`
    }
];
const Privacy = () => {
    return (
        <div className="privacy">
            <h1>Privacy Policy</h1>
            {sections.map((section) => (
                <motion.div
                    key={section.title}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="privacy-section"
                >
                    <h2>{section.title}</h2>
                    <p>{section.content}</p>
                </motion.div>
            ))}
        </div>
    );


};

export default Privacy;